import React, { useEffect, useState } from "react";
import "./footer.scss";
import { Container, Row, Col, Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

export default function Footer() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [pathname]);

    const [activeSection, setActiveSection] = useState("");

    useEffect(() => {
        const sections = document.querySelectorAll("section[id]");
        const options = { threshold: 0.6 };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setActiveSection(entry.target.id);
                }
            });
        }, options);

        sections.forEach((section) => observer.observe(section));

        return () => observer.disconnect();
    }, []);

    return (
        <React.Fragment>
            <footer className="footer">
                <Container>
                    <div className="footer-top">
                        <Row className="gy-4">

                            <Col md={4} className="footer-col">
                                <h5 className="text-uppercase">Quick Links</h5>
                                <ul>
                                    <li><Nav.Link as={Link} to="/">Home</Nav.Link></li>
                                    <li><Nav.Link as={Link} to="/full-fleet">Our Fleet</Nav.Link></li>
                                    <li><Nav.Link as={HashLink} smooth to="/#experiences">Experiences</Nav.Link></li>
                                    <li><Nav.Link as={Link} to="/safety-guidelines">Safety</Nav.Link></li>
                                    <li><Nav.Link as={HashLink} smooth to="/#contact">Contact</Nav.Link></li>
                                </ul>
                            </Col>
                            <Col md={4} className="footer-col">
                                <h5 className="text-uppercase">Services</h5>
                                <ul>
                                    <li><Nav.Link as={HashLink} smooth to="/#experiences">Luxury Yacht Charters</Nav.Link></li>
                                    <li><Nav.Link as={HashLink} smooth to="/#experiences">Speed Boat Rentals</Nav.Link></li>
                                    <li><Nav.Link as={HashLink} smooth to="/#experiences">Sunset Cruises</Nav.Link></li>
                                    <li><Nav.Link as={HashLink} smooth to="/#experiences">Corporate Events</Nav.Link></li>
                                    <li><Nav.Link as={HashLink} smooth to="/#experiences">Private Celebrations</Nav.Link></li>
                                    <li><Nav.Link as={HashLink} smooth to="/#experiences">Wedding Proposals</Nav.Link></li>
                                </ul>
                            </Col>

                            <Col md={4} className="footer-col">
                                <h5 className="text-uppercase">Support</h5>
                                <ul>
                                    <li><Nav.Link as={HashLink} className={activeSection === "privacy-policy" ? "active" : ""} to="privacy-policy" eventKey="privacy-policy">
                                        Privacy Policy
                                    </Nav.Link>
                                    </li>
                                    <li><Nav.Link as={HashLink} className={activeSection === "terms-of-use" ? "active" : ""} to="terms-of-use" eventKey="terms-of-use">
                                        Terms of Use
                                    </Nav.Link>
                                    </li>
                                    <li><Nav.Link as={HashLink} className={activeSection === "safety-guidelines" ? "active" : ""} to="safety-guidelines" eventKey="safety-guidelines">
                                        Safety Guidelines
                                    </Nav.Link>
                                    </li>
                                </ul>

                                <hr />
                                <ul>
                                    <li><Nav.Link as="a" href="tel:+917666689265">+91 76666 89265</Nav.Link></li>
                                </ul>


                            </Col>
                        </Row>
                    </div>

                    <div className="bottom-footer text-center">
                        <p>© 2025 Book Sailing Mumbai. All rights reserved.</p>
                    </div>
                </Container>
            </footer>
        </React.Fragment>
    )
}